// @flow strict

import React, { type Node, type Component } from 'react';
import { MuiThemeProvider } from '@material-ui/core';

import { LanguageWrapper } from '~contexts/language-context';

import { defaultTheme } from '../themes/default';

type AppProps = {
  children: Node,
  language: string,
};

type TemplateProps = {|
  data: {},
  pageContext: {
    language: string,
  },
|};

const App = ({ language, children }: AppProps) => {
  return (
    <MuiThemeProvider theme={defaultTheme}>
      <LanguageWrapper language={language}>{children}</LanguageWrapper>
    </MuiThemeProvider>
  );
};

// type for hoc wrapper
export type AppHOCType<T> = (props: T & TemplateProps) => Node;

export function withApp<T>(Component: (props: T) => Node): AppHOCType<T> {
  return function WrappedWithApp(props: T & TemplateProps) {
    const { pageContext } = props;

    return (
      <App language={pageContext.language}>
        <Component {...props} />
      </App>
    );
  };
}
